import { CategoryID } from '@sbt-web/network/types';

export const titleCustomStrings: Record<CategoryID, string> = {
  [CategoryID.Tutte]: 'case, auto, lavoro e altro',
  [CategoryID.Motori]: 'veicoli usati',
  [CategoryID.Auto]: 'auto usate',
  [CategoryID.AccessoriAuto]: 'ricambi per auto',
  [CategoryID.Moto]: 'moto e scooter usati',
  [CategoryID.AccessoriMoto]: 'accessori moto',
  [CategoryID.Nautica]: 'barche usate',
  [CategoryID.CaravanECamper]: 'caravan e camper usati',
  [CategoryID.VeicoliCommerciali]: 'camion, trattori e macchine usate',
  [CategoryID.Immobili]: 'case',
  [CategoryID.Appartamenti]: 'appartamenti',
  [CategoryID.CamerePostiLetto]: 'camere e posti letto',
  [CategoryID.Ville]: 'ville',
  [CategoryID.TerreniRustici]: 'terreni e rustici',
  [CategoryID.GarageBox]: 'box e garage',
  [CategoryID.LoftMansarde]: 'loft, mansarde e altro',
  [CategoryID.CaseVacanza]: 'appartamenti vacanza',
  [CategoryID.UfficiLocali]: 'uffici e locali',
  [CategoryID.LavoroServizi]: 'Lavoro e Servizi',
  [CategoryID.OfferteLavoro]: 'Annunci di lavoro',
  [CategoryID.Servizi]: 'servizi',
  [CategoryID.Candidati]: 'Trova lavoro',
  [CategoryID.Attrezzature]: 'occasioni usato',
  [CategoryID.Elettronica]: 'prodotti informatici',
  [CategoryID.Informatica]: 'computer online',
  [CategoryID.ConsoleVideogiochi]: 'giochi per pc, xbox, playstation',
  [CategoryID.AudioVideo]: 'audio e video usato',
  [CategoryID.Fotografia]: 'macchine fotografiche digitali',
  [CategoryID.Telefonia]: 'cellulari usati',
  [CategoryID.CasaPersona]: 'oggetti per la casa e la persona',
  [CategoryID.ArredamentoCasalinghi]: 'mobili usati',
  [CategoryID.Elettrodomestici]: 'elettrodomestici usati',
  [CategoryID.GiardinoFaiDaTe]: 'arredamento da giardino',
  [CategoryID.AbbigliamentoAccessori]: 'abbigliamento e accessori',
  [CategoryID.TuttoBambini]: 'mobili, camerette e giocattoli',
  [CategoryID.SportsHobby]: 'articoli tempo libero',
  [CategoryID.Animali]: 'e regalo animali e cuccioli',
  [CategoryID.MusicaFilm]: 'musica e film',
  [CategoryID.AccessoriAnimali]: 'accessori per animali',
  [CategoryID.LibriRiviste]: 'libri usati',
  [CategoryID.StrumentiMusicali]: 'strumenti musicali',
  [CategoryID.Sports]: 'accessori per lo sport',
  [CategoryID.Biciclette]: 'biciclette nuove e usate',
  [CategoryID.Collezionismo]: 'antiquariato, mobili e oggetti da collezione',
  [CategoryID.Altri]: 'usato',
  [CategoryID.AltriAnnunci]: 'usato',
};

export const descriptionCustomStrings: Record<CategoryID, string> = {
  [CategoryID.Tutte]: 'auto, case e oggetti vari nuovi e usati',
  [CategoryID.Motori]:
    'annunci di privati e di concessionarie e trova oggi il tuo veicolo usato',
  [CategoryID.Auto]:
    'annunci di privati e di concessionarie e trova oggi auto nuove e usate',
  [CategoryID.AccessoriAuto]:
    'annunci di privati e di negozi e trova ricambi per auto',
  [CategoryID.Moto]:
    'annunci di privati e di concessionarie e trova moto nuove e usate',
  [CategoryID.AccessoriMoto]:
    'annunci di privati e di negozi e trova ricambi per moto',
  [CategoryID.Nautica]:
    'annunci di privati e di negozi e trova la tua futura barca',
  [CategoryID.CaravanECamper]:
    'annunci di privati e di concessionarie e trova il tuo futuro camper',
  [CategoryID.VeicoliCommerciali]:
    'annunci di camion, trattori e macchine da lavoro',
  [CategoryID.Immobili]:
    'annunci di privati e di agenzie e trova oggi la tua futura casa',
  [CategoryID.Appartamenti]:
    'annunci di privati e di agenzie e trova la tua futura casa',
  [CategoryID.CamerePostiLetto]:
    'annunci di privati e di agenzie e trova dove abitare',
  [CategoryID.Ville]: 'annunci di privati e di agenzie e trova casa',
  [CategoryID.TerreniRustici]:
    'annunci di privati e di agenzie e trova nuovi terreni',
  [CategoryID.GarageBox]:
    'annunci di privati e di agenzie e trova un nuovo posto auto',
  [CategoryID.LoftMansarde]:
    'annunci di privati e di agenzie e trova la tua nuova casa',
  [CategoryID.CaseVacanza]:
    'annunci di case, appartamenti, camere, agriturismi e B&B',
  [CategoryID.UfficiLocali]: 'annunci di privati e di agenzie e trova uffici',
  [CategoryID.LavoroServizi]:
    'annunci di aziende, agenzie e privati e trova il tuo nuovo impiego',
  [CategoryID.OfferteLavoro]:
    'offerte di aziende, agenzie e privati e trova il tuo nuovo lavoro',
  [CategoryID.Servizi]:
    'annunci di aziende e privati che offrono servizi di varia natura',
  [CategoryID.Candidati]: 'annunci di privati e trova il tuo nuovo dipendente',
  [CategoryID.Attrezzature]:
    'annunci di aziende e privati e trova nuova attrezzatura',
  [CategoryID.Elettronica]:
    'annunci di prodotti informatici e trova il tuo nuovo dispositivo',
  [CategoryID.Informatica]:
    'annunci di computer, mac, pc fissi e portatili nuovi e usati',
  [CategoryID.ConsoleVideogiochi]:
    'annunci di console e giochi per pc, xbox e playstation usati',
  [CategoryID.AudioVideo]:
    'annunci di prodotti audio e video e trova la tua videocamera',
  [CategoryID.Fotografia]:
    'annunci di macchine fotografiche digitali nuove e usate',
  [CategoryID.Telefonia]:
    'annunci di cellulari, smartphone e tablet nuovi e usati',
  [CategoryID.CasaPersona]: 'annunci di prodotti per la casa e per la persona',
  [CategoryID.ArredamentoCasalinghi]:
    'annunci di mobili usati e trova il tuo nuovo arredo',
  [CategoryID.Elettrodomestici]:
    'annunci di elettrodomestici nuovi e usati per la tua casa',
  [CategoryID.GiardinoFaiDaTe]:
    'annunci di prodotti per la casa e per la persona',
  [CategoryID.AbbigliamentoAccessori]:
    'annunci di vestiti, scarpe, collane e molto altro',
  [CategoryID.TuttoBambini]: 'annunci di mobili, camerette e giocattoli usati',
  [CategoryID.SportsHobby]:
    'annunci di articoli e oggetti per il tuo tempo libero',
  [CategoryID.Animali]:
    'annunci di animali e cuccioli e trova nuovi amici a quattro zampe',
  [CategoryID.AccessoriAnimali]: 'annunci di accessori per animali',
  [CategoryID.MusicaFilm]:
    'strumenti musicali, CD, cassette, VHS, DVD e Blue-Ray usati',
  [CategoryID.LibriRiviste]:
    'annunci di libri, romanzi, riviste, manga e fumetti usati',
  [CategoryID.StrumentiMusicali]:
    'annunci di chitarre, bassi, batterie, tastiere e violini',
  [CategoryID.Sports]:
    'annunci di attrezzatura e accessori usati per il tuo sport preferito',
  [CategoryID.Biciclette]:
    'annunci di biciclette nuove e usate per adulti e bambini',
  [CategoryID.Collezionismo]:
    'annunci di antiquariato, mobili e oggetti da collezione',
  [CategoryID.Altri]: 'annunci di usato di oggetti vari',
  [CategoryID.AltriAnnunci]: 'annunci di usato di oggetti vari',
};
